import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { UserSettings } from './usersettings';

@Component({
    selector: 'acc-template-jv',
    template: require('./accountTemplatejv.html'),
    styles: [``]
})
export class AccountTemplateJVComponent implements OnInit {
   
    @Input('accountList') accountList: any;
    @Input("cValue") cValue :any;
    @Input( "dValue")  dvalue :any;
    @Output() SelectedAccount = new EventEmitter();
    static parameters = [UtilityService]
    constructor(public utilityService: UtilityService) { }
    gridApiAcc: any;
    gridColumnApiAcc: any;
    paginationConf:any;
    glList: any;
    glDef1: any;
    selectedAccountInfo: any;
    defaultColDef:any;
    d:any;
    filterType:any;

    rowSelectionSingle: string;
    searchValue: any;
    ngOnInit(): void {
      //   console.log('account template init!');
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.paginationConf = true;
    }
    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }
    onGridReadyAcc(params) {
        this.glDef1 = [
            { headerName: 'GL Code', field: 'GL_Code', width: 110,  cellRenderer: this.highlightRenderer  },
            { headerName: 'GL Desc', field: 'GL_Desc', width: 260 },
            { headerName: 'Reco Group', field: 'RecoGroup', width: 150 },
            { headerName: 'Party Code', field: 'Party_Code', width: 150 },
            { headerName: 'Party Name', field: 'Party_Name', width: 260,  cellRenderer: this.highlightRenderer  },
            { headerName: 'Party Address', field: 'Party_Full_Address', width: 260 },
            { headerName: 'Party Area', field: 'Party_Area_Name', width: 150 },
            { headerName: 'Party City', field: 'Party_City_Desc', width: 150 },
            { headerName: 'Party State', field: 'Party_State_Desc', width: 150 },
            
        ];
       
        // this.glList = this.accountList.data;
      //   console.log('accountList', this.glList);
      //   console.log("param on ready:", params);
        this.gridApiAcc = params.api;
        this.gridColumnApiAcc = params.columnApi;
      this.glList = this.accountList && this.accountList.data || [];
      this.precomputeSearchFields(); // ✅ precompute here
      this.gridApiAcc.setRowData(this.glList);
      setTimeout( () => {
        this.gridApiAcc.sizeColumnsToFit();
        
      //   console.log(this.selectedAccountInfo);
      }, 1);
  //   this.gridColumnApiCust.autoSizeColumns(allColumnIds);
   
     this.defaultColDef = {
         resizable: true,
     };
   
       
       
    }
    gridEventDown(event) {
        if (event.keyCode == 13) {
          //   console.log("keydown", event);
            this.accSelectionMain(this);
        } else if (event.keyCode == 8) {
            setTimeout(() => {
                $('#filter-text-box').focus().select();
            }, 200);
        } else if (event.keyCode >= 65 && event.keyCode <= 90) {
            $('#filter-text-box').focus().select();
        }
    }
    private accSelectionMain(self: this) {
        let selectedRows = self.gridApiAcc.getSelectedRows();
        let cust = selectedRows[0];
      //   console.log("selected Acc:", selectedRows[0]);

        if (cust != undefined) {
          //   console.log('selected account:', cust);
            this.SelectedAccount.emit(cust);
        }
       
    }
  
    invoiceInfo: any;
    accSelected(event) {
        let selectedRowCust = this.gridApiAcc.getSelectedRows();
      //   console.log("selectedRows", selectedRowCust[0]);
        this.selectedAccountInfo = selectedRowCust[0];
        // this.todayD = moment(this.salesorder.Return_Invoice_Date).format(this.dateFormat.dateInputFormat);
      //   console.log(this.selectedAccountInfo.GL_Desc);
    }
    onAccSelectionChanged(event) {
        this.accSelectionMain(this);
    }
    // quickSearch(event, id) {
    //     if (id == 'product') {
    //         // this.gridApiPrd.setQuickFilter(this.searchValue);
    //         // this.gridApiPrd.onFilterChanged();
    //         // this.gridApiPrd.getModel().getRow(0).setSelected(true);
    //         // this.productFilterd = this.gridApiPrd.getModel().getRowCount().toLocaleString();
    //         // if (event.which == 13 || event.which == 40) {
    //         //     this.gridApiPrd.setFocusedCell(0, "Product_Code");
    //         // }
    //     }
    //     else if (id == 'account') {
    //         this.filterType = 'Party_Name';
    //         var IsSearchContain = "";
    //         var sportsFilterComponent = this.gridApiAcc.getFilterInstance(this.filterType);
    //         if (this.searchValue) {
              
    //           let search = (this.searchValue ? this.searchValue.toString() : "").trim();
    //           let search1 = search.split(" ");
    //           var Slen1 = search.length;
    //           var Slen = search1.length;
    //           if (Slen1 >= 3) {
    //               sportsFilterComponent.setModel({
    //                   type: "contains",
    //                   filter: search
    //               });                    
    //               this.gridApiAcc.onFilterChanged();
    //               if (this.gridApiAcc.getModel().getRowCount() == 0) {
    //                   if (Slen > 1) {
    //                       sportsFilterComponent.setModel({
    //                           condition2: {
    //                               type: "contains",
    //                               filter: search1[1]
    //                           },
    //                           condition1: {
    //                               type: "contains",
    //                               filter: search1[0]
    //                           },
    //                           condition3: {
    //                               type: "contains",
    //                               filter: search1[1]
    //                           },
    //                           operator: "AND"
    //                       });
    //                   } else {
    //                       var index = search.indexOf("%");
    //                       if (index >= 0) {
    //                           search = search.replace(/%/g, "");
    //                           IsSearchContain = search;
    //                       }
    //                       sportsFilterComponent.setModel({
    //                           type: (index >= 0) ? "contains" : "contains",
    //                           filter: search
    //                       });
    //                       if (index < 0) {
    //                           this.gridApiAcc.onFilterChanged();
    //                           if (this.gridApiAcc.getModel().getRowCount() == 0) {
    //                               sportsFilterComponent.setModel({
    //                                   type: "contains",
    //                                   filter: search
    //                               });
    //                           }
    //                       }
    //                   }
    //               } else {
    //                   IsSearchContain = search;
    //               }
    //           } else {
    //               this.gridApiAcc.setFilterModel(null);
    //           }
    //       } else {
    //           this.gridApiAcc.setFilterModel(null);
    //       }
    //     }
    // }

    onFilterTextBoxChanged() {
        let value = $('input#filter-text-box').val();
        this.gridApiAcc.setQuickFilter(value);
    }

    onSerachBoxFilterChanged(e){
      let value = $('input#filter-text-box').val();
      this.gridApiAcc.setQuickFilter(value);

      this.gridApiAcc.onFilterChanged();
      if (this.gridApiAcc.getModel().getRowCount() > 0) {
          this.gridApiAcc.getModel().getRow(0).setSelected(true);
      }
      if (e.which == 13 || e.which == 40) {
        this.gridApiAcc.setFocusedCell(0, "GL_Code");
      }
    }
// Call this once after data fetch
precomputeSearchFields() {
  const normalize = (s: any) =>
    (s === null || s === undefined ? '' : s.toString())
      .toLowerCase()
      .replace(/[^a-z0-9]/g, ''); // removes spaces and punctuation

  this.glList.forEach(row => {
    // Precomputed full-text search field
    row._searchText = normalize(Object.values(row).join(' '));

    // Precomputed priority field (Party_Name + GL_Code)
    row._primarySearchText = normalize(`${row.Party_Name || ''} ${row.GL_Code || ''}`);
  });
}

  // searchValue = '';
  // component properties
  searchValueTerms: string[] = [];

  // call this from the input (use (input) as before)
  onSmartSearchChanged(e) {
    // console.log('onSmartSearchChanged', e);
    const raw = (e.target.value || '').trim().toLowerCase();

    // split into terms first, then normalize each term
    this.searchValueTerms = raw
      .split(/\s+/)                 // split on whitespace
      .filter(Boolean)             // remove empty
      .map(t => t.replace(/[^a-z0-9]/g, '')); // remove non-alphanumerics

    // trigger grid filter
    if (this.gridApiAcc) this.gridApiAcc.onFilterChanged();

    // if (this.gridApiAcc.getModel().getRowCount() > 0) {
    //   this.gridApiAcc.getModel().getRow(0).setSelected(true);
    //   this.gridApiAcc.setFocusedCell(0, "GL_Code");
    // }
    // if (e.which == 13 || e.which == 40) {
    //   this.gridApiAcc.setFocusedCell(0, "GL_Code");
    // }
  }
  onSearchKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === 'ArrowDown') {
      event.preventDefault(); // stop cursor from moving in the input
      this.focusFirstRow();
    }
  }

  focusFirstRow() {
    if (this.gridApiAcc) {
      // Focus first cell in first row
      this.gridApiAcc.setFocusedCell(0, "GL_Code");
      this.gridApiAcc.ensureIndexVisible(0);
    }
  }
  isExternalFilterPresent() {
    return Array.isArray(this.searchValueTerms) && this.searchValueTerms.length > 0;
  }

  doesExternalFilterPass(node) {
    /*
    if (!this.isExternalFilterPresent()) return true;
  
    // normalizer for row text: join all values, lowercase, remove non-alphanumerics
    const normalize = (s: any) =>
      (s === null || s === undefined ? '' : s.toString())
        .toLowerCase()
        .replace(/[^a-z0-9]/g, ''); // removes spaces and punctuation
  
    // Priority text (Party_Name + GL_Code)
    const primaryText = normalize(`${node.data.Party_Name || ''} ${node.data.GL_Code || ''}`);
  
    // If all terms match the primaryText, pass
    if (this.searchValueTerms.every(term => primaryText.includes(term))) return true;
  
    // Fallback: full row text
    const rowText = normalize(Object.values(node.data).join(' '));
  
    return this.searchValueTerms.every(term => rowText.includes(term));
    */

    if (!this.isExternalFilterPresent()) return true;

    if (this.searchValueTerms.every(term => node.data._primarySearchText.includes(term))) {
      return true;
    }

    return this.searchValueTerms.every(term => node.data._searchText.includes(term));
  }
  highlightRenderer = (params) => {
    if (!this.isExternalFilterPresent()) return params.value;

    let value = params && params.value!.toString() || '';
    const lcValue = value.toLowerCase();

    this.searchValueTerms.forEach(term => {
      if (term && lcValue.includes(term)) {
        const regex = new RegExp(`(${term})`, 'gi');
        value = value.replace(regex, '<mark>$1</mark>');
      }
    });

    return value;
  };
}
